import './contact.scss';
import { useEffect, useState } from 'react';
import PanelRecurso from 'components/templates/panelRecurso/PanelRecurso';
import SearchInput from 'components/commons/inputs/SearchInput/SearchInput';
import Button from 'components/commons/buttons/button/Button';
import { ReactComponent as Ic_info } from 'resources/icons/Ic_Info.svg';
import { updateMarkers, flyTo } from 'redux/slices/mapSlice';
import ImagePromise from 'components/widgets/imagePromise/ImagePromise';
import { useTranslate } from 'context/languageContext';
import UseSEO from 'hooks/useSEO/UseSEO';
import { ReactComponent as Ic_Sort } from 'resources/icons/Ic_sort.svg';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CardItemCategory from 'components/features/cardItemCategory/CardItemCategory';
import MarkerDetailCard from 'components/features/markerDetailCard/MarkerDetailCard';
import MapContainerScreen from 'screens/mapContainerScreen/MapContainerScreen';
import { set } from 'redux/slices/plannerSegmentsSlice';
import { contactDataState } from 'redux/slices/webSlice';
import { emtOfficePoisState } from 'redux/slices/poisSlices';
import { updateShowSubMenu } from 'redux/slices/subMenuSlices';
import { RUTAS_GENERALES_MUL2, EMT_OFFICE_SECTION_ID, TYPES_MARKERS } from 'utils/constants';
import DOMPurify from 'dompurify';
import { useRef } from 'react';
import { scrollTop } from 'utils/utils';
import PlanUtils from 'utils/PlanUtils';
import { poisFavoritesState } from 'redux/slices/favoritesSlice';
import { inputScrollTop } from 'utils/utils';

const PALMA_BOUNDS_CENTER = {
  lat: 39.570589,
  lng: 2.652082,
};
const ZOOM = 16;

export const phoneFormater = (phone: any) => {
  try {
    // const prefix = '';
    const prefix = '(+34) ';
    const a = String(phone).slice(0, 3);
    const b = String(phone).slice(3, 6);
    const c = String(phone).slice(6, 9);
    return `${prefix} ${a} ${b} ${c}`;
  } catch (error) {
    return error;
  }
};

export default function Contact({ precarga }) {
  const controllerRef = useRef() as any;
  const t = useTranslate();
  const [generateUrl, generateTitleAndMeta] = UseSEO();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [ loading, setLoading ] = useState(true);
  const [selected, setSelected] = useState<any>(null);
  const clickNaV = (itemSelected) => {
    dispatch(set({ index: 1, overwrite: true, stop: itemSelected }));
    navigate(generateUrl(RUTAS_GENERALES_MUL2.planner));
  };
  const filteredPoisSelector = useSelector(emtOfficePoisState);
  const favoritePoisSelector = useSelector(poisFavoritesState);
  const debounce = <T extends any[]>(func: (...args: T) => void, delay: number) => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    return function (this: any, ...args: T) {
      clearTimeout(timer);
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      const controller = new AbortController();
      controllerRef.current = controller;

      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const searchQuestionByText = debounce((text) => {
    // setLoading(true);
    if (text.length === 0) return inputFiltering('');
    inputFiltering(text);
  }, 400);

  const FORMATED_POIS = filteredPoisSelector?.map((item, i) => {
    const formartedMarker = {
      poiCategoryId: item.poiCategoryId,
      name: item.name,
      code: item.id,
      description: item.description,
      id: item.id,
      position: { lat: Number(item.poiLat), lng: Number(item.poiLon) },
      onClick: () => handleCardClick(item.id),
      transportMode: 1,
      stopCode: null,
      selected: false,
      popUp: true,
      topName:
        Number(item?.data?.iconPoiCategory?.section) === Number(EMT_OFFICE_SECTION_ID)
          ? 'EMT Palma'
          : null,
      data: item?.data,
      type: TYPES_MARKERS.POI,
    };
    const popUpElement = <MarkerDetailCard marker={formartedMarker} onClose={()=> {setSelected(null);renderContactMarkers(poisFiltrados, PALMA_BOUNDS_CENTER, ZOOM);}}/>;
    return { ...formartedMarker, popUpElement };
  });
  const [poisFiltrados, setPoisFiltrados] = useState<any>(FORMATED_POIS);
  const selectorContactData = useSelector(contactDataState);
  const FULL_ADDRESS =
    selectorContactData &&
    `${selectorContactData?.street} ${selectorContactData?.streetNumber}. ${selectorContactData?.postalCode} ${selectorContactData?.city}`;
  const [ascendent, setAscendent] = useState(false);

  const goTo = (id) => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  };

  const isSelected = (id) => {
    let s = false;
    if (Number(id) === Number(selected?.id)) s = true;
    return s;
  };

  const handleCardClick = (poiId) => {
    try {
      if (selected) {
        setSelected(null);
        inputScrollTop('map-panel-wrapper');
      }
      const isSelectedPoi = FORMATED_POIS?.find((poi) => Number(poi?.id) === Number(poiId));
      if (FORMATED_POIS?.length) {
        if (selected?.id === poiId) {
          // const CALCULATED_COORDS_ALL = PlanUtils.getMidPoint({longitude:FORMATED_POIS[FORMATED_POIS.length-1]?.position?.lng, latitude:FORMATED_POIS[FORMATED_POIS.length-1]?.position?.lat},{longitude:FORMATED_POIS[0]?.position?.lng, latitude:FORMATED_POIS[0]?.position?.lat});
          // const CALCULATED_ZOOM_ALL = PlanUtils.getMidZoom({longitude:FORMATED_POIS[FORMATED_POIS.length-1]?.position?.lng,latitude:FORMATED_POIS[FORMATED_POIS.length-1]?.position?.lat}, {longitude:FORMATED_POIS[0]?.position?.lng ,latitude:FORMATED_POIS[0]?.position?.lat});
          renderContactMarkers(poisFiltrados, PALMA_BOUNDS_CENTER, ZOOM);
        } else {
          const CALCULATED_COORDS = PlanUtils.getMidPoint(
            { longitude: isSelectedPoi?.position?.lng, latitude: isSelectedPoi?.position?.lat },
            { longitude: isSelectedPoi?.position?.lng, latitude: isSelectedPoi?.position?.lat },
          );
          const CALCULATED_ZOOM = PlanUtils.getMidZoom(
            { longitude: isSelectedPoi?.position?.lng, latitude: isSelectedPoi?.position?.lat },
            { longitude: isSelectedPoi?.position?.lng, latitude: isSelectedPoi?.position?.lat },
          );
          setSelected(isSelectedPoi);
          inputScrollTop('map-panel-wrapper');
          const selectedMarker = { ...isSelectedPoi, selected: true };
          renderContactMarkers([selectedMarker], CALCULATED_COORDS, CALCULATED_ZOOM);
          if (isSelectedPoi) goTo('CardItemCategory' + isSelectedPoi.id);
        }
      }
    } catch (error) {
      return error;
    }
  };
  const getFormatedPois = (pois) => {
    setPoisFiltrados(pois);
  };

  const renderContactInfo = (res) => {
    const htmlContent = res;
    const sanitizedHtmlContent = DOMPurify.sanitize(htmlContent);
    return sanitizedHtmlContent;
  };

  const inputFiltering = (text) => {
    try {
      if (!text) return setPoisFiltrados(FORMATED_POIS);
      setPoisFiltrados(FORMATED_POIS.filter((poi) => poi.name.toLowerCase().includes(text.toLowerCase())));
    } catch (error) {
      return error;
    } finally {
      // setLoading(false);
    }
  };

  const sortPois = () => {
    setAscendent(!ascendent);
  };

  const renderContactMarkers = (poiMarkers, coords, zoom) => {
    if (poiMarkers.length) {
      dispatch(updateMarkers(poiMarkers));
      dispatch(
        flyTo({
          coords,
          zoom,
        }),
      );
    }
  };

  // useEffect(() => {
  //   const el = document.getElementsByClassName('leaflet-container');
  //   el[0]?.classList.add('leaflet-container-radius');

  //   scrollTop();
  //   dispatch(updateMarkers([]));
  //   getFormatedPois(FORMATED_POIS);

  //   return () => {
  //     el[0]?.classList.remove('leaflet-container-radius');
  //   };
  // }, [filteredPoisSelector]);

  // useEffect(() => {
  //   renderContactMarkers(FORMATED_POIS, PALMA_BOUNDS_CENTER, ZOOM);
  // }, [FORMATED_POIS]);

  // useEffect(() => {
  //   if (poisFiltrados.length > 0) {
  //     const sortedPois = poisFiltrados.slice().sort((p1, p2) => {
  //       return ascendent ? p1.name.localeCompare(p2.name) : p2.name.localeCompare(p1.name);
  //     });
  //     setPoisFiltrados(sortedPois);
  //   }
  // }, [ascendent]);

  /* ********************************** */
  useEffect(() => {
    dispatch(updateShowSubMenu(true));
    scrollTop();
  }, []);

  useEffect(()=>{
    if(selected) {
      const aux = selected;
      setSelected(null);
      setTimeout(()=>{
        const CALCULATED_COORDS = PlanUtils.getMidPoint(
          { longitude: aux?.position?.lng, latitude: aux?.position?.lat },
          { longitude: aux?.position?.lng, latitude: aux?.position?.lat },
        );
        const CALCULATED_ZOOM = PlanUtils.getMidZoom(
          { longitude: aux?.position?.lng, latitude: aux?.position?.lat },
          { longitude: aux?.position?.lng, latitude: aux?.position?.lat },
        );
        setSelected(aux);
        const selectedMarker = { ...aux, selected: true };
        renderContactMarkers([selectedMarker], CALCULATED_COORDS, CALCULATED_ZOOM);
      }, 50);
    }
  },[favoritePoisSelector]);

  useEffect(() => {
    getFormatedPois(FORMATED_POIS);
    return () => {
      dispatch(updateMarkers([]));
    };
  }, [filteredPoisSelector]);

  useEffect(() => {
    if (poisFiltrados.length > 0) {
      const sortedPois = poisFiltrados.slice().sort((p1, p2) => {
        return ascendent ? p1.name.localeCompare(p2.name) : p2.name.localeCompare(p1.name);
      });
      setSelected(null);
      setPoisFiltrados(sortedPois);
    }
  }, [ascendent]);

  useEffect(() => {
    renderContactMarkers(FORMATED_POIS, PALMA_BOUNDS_CENTER, ZOOM);
  }, [poisFiltrados, favoritePoisSelector]);

  return (
    <>
      <main className='main-container'>
        {generateTitleAndMeta(
          t('lb_seo_title_atencion_cliente'),
          t('lb_seo_description_atencion_cliente'),
        )}

        <div className='contact-container'>
          <article className='contact-card'>
            <div className='contact-item'>
              {selectorContactData?.imageId && (
                <ImagePromise imageId={selectorContactData?.imageId} />
              )}
            </div>

            <div className='contact-item info'>
              <h1>{t('lb_info_contacto')}</h1>
              <h2>{t('lb_oficina_atcliente')}</h2>
              <p>{FULL_ADDRESS}</p>
              <p>{selectorContactData?.phoneOne && phoneFormater(selectorContactData?.phoneOne)}</p>
              <p>{selectorContactData?.phoneTwo && phoneFormater(selectorContactData?.phoneTwo)}</p>
              <a href={`mailto:${selectorContactData?.email}`}>{selectorContactData?.email}</a>
            </div>

            <div className='contact-item public-atention'>
              <h2>{t('lb_horarios_atcliente')}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: renderContactInfo(selectorContactData?.schedules),
                }}
              ></div>
            </div>
          </article>
          <div className='contact-map-title'>
            <div className='title-box'>
              <SvgIcon Icon={Ic_info} />
              <h1>{t('lb_oficina_atcliente_ayuntamiento_palma')}</h1>
            </div>
            <p>{t('lb_gestiones_tarjeta_ciudadana')}</p>
          </div>
        </div>
      </main>
      <div className='map-panel-wrapper' id='map-panel-wrapper'>
        <MapContainerScreen precarga={true} />
        <PanelRecurso className='contact-panel-recurso'>
          <div className='contact-input-box' id='input-box-contact'>
            <SearchInput
              name='input-box-contact'
              placeholder={t('lb_oficina_palama_oac')}
              actionOnChange={(e) => searchQuestionByText(e)}
              iconLeft={null}
              style={{ marginRight: 8 }}
              value={''}
              onClear={() => {}}
              onFocus={() => {
                inputScrollTop('input-box-contact');
              }}
            />
            <Button title='' onClick={() => sortPois()}>
              <SvgIcon
                Icon={Ic_Sort}
                className={`contact-sort ${ascendent ? '--ascendent' : ''}`}
              />
            </Button>
          </div>

          <div className='box-atclient-results'>
            {poisFiltrados.length > 0 ? (
              poisFiltrados.map((item, i) => (
                <CardItemCategory
                  key={'CardItemCategoryContact' + item.id}
                  elementId={'CardItemCategoryContact' + item.id}
                  title={item.name}
                  description={item.description}
                  onClickNav={() => clickNaV(item)}
                  onClick={() => handleCardClick(item.id)}
                  selected={isSelected(item.id)}
                  background={item?.data?.iconPoiCategory?.color}
                  iconId={item?.data?.iconPoiCategory?.iconId}
                />
              ))
            ) : (
              <div className='explore_noResults'>{t('lb_No_encontado')}</div>
            )}
          </div>
        </PanelRecurso>
      </div>
    </>
  );
}
